import { CloseOutlineIcon } from '@carboncopyco/icons';
import classNames from 'classnames';
import type { ReactNode } from 'react';
import { ColorHex, type Colors } from '../../constants';
import { Spacer } from '../Spacer';
import { TextCaption } from '../Typography';

export interface TooltipMessageProps {
  /** tooltip title */
  title?: string | ReactNode;
  /** tooltip message */
  message?: string | ReactNode;
  /** optional left-hand icon  */
  icon?: ReactNode;
  /** optional button inside the tooltip  */
  button?: ReactNode;
  /** X icon, should be false when parent Tooltip is triggered on hover */
  closeIcon?: boolean;
  /** callback to close the tooltip on X (should be passed from the Tooltip parent) */
  onClose?: () => void;
  /** optional boolean (default true) to apply `whitespace-nowrap` class enables words of message not to break to lines  */
  wrapMessage?: boolean;
  /** optional title color */
  titleColor?: Colors;
}

export const TooltipMessage = ({
  title,
  message,
  icon,
  button,
  closeIcon = false,
  onClose,
  wrapMessage = true,
  titleColor,
}: TooltipMessageProps) => {
  return (
    <div
      className={classNames([
        'flex px-4',
        button ? 'pt-2.5' : 'py-2.5',
        wrapMessage ? 'whitespace-normal' : 'whitespace-nowrap',
      ])}
    >
      {icon && (
        <>
          <div className="-mt-1">{icon}</div>
          <Spacer />
        </>
      )}
      <div className="flex flex-col bg-ds-accent3-100">
        {typeof title === 'string' ? (
          <TextCaption
            label={title}
            color={titleColor || 'text-ds-natural-600'}
          />
        ) : (
          title
        )}
        <div className="w-max flex items-center">
          {typeof message === 'string' ? (
            <TextCaption label={message} />
          ) : (
            message
          )}
          {button}
        </div>
      </div>
      {closeIcon && (
        <div
          className="ml-auto cursor-pointer h-full -mt-0.5"
          onClick={onClose}
        >
          <CloseOutlineIcon color={ColorHex.natural200} />
        </div>
      )}
    </div>
  );
};
